var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownGe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54164",
    "data-name": "Group 54164",
    transform: "translate(0 10) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5334",
    "data-name": "Rectangle 5334",
    width: 3.333,
    height: 3.4,
    transform: "translate(6.667)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5335",
    "data-name": "Rectangle 5335",
    width: 3.333,
    height: 3.4,
    transform: "translate(3.333 3.4)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5338",
    "data-name": "Rectangle 5338",
    width: 3.333,
    height: 3.4,
    transform: "translate(0 6.8)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5339",
    "data-name": "Rectangle 5339",
    width: 3.333,
    height: 3.4,
    transform: "translate(6.667 13.6)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5337",
    "data-name": "Rectangle 5337",
    width: 3.333,
    height: 3.4,
    transform: "translate(3.333 10.2)",
    fill: "#15081f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownGe);
export default __webpack_public_path__ + "static/media/dropdown-ge.8fcc71fd9af3f1b3d4fc1f03f0bd9f11.svg";
export { ForwardRef as ReactComponent };